export default __webpack_public_path__ + "static/media/海外募集型企画旅行 旅行条件書（RTCC 海外宿泊プラン）.e04a0455.pdf";